module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.applyStaffName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所在部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.departmentName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("行政级别")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.applyStaffRank))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("申请信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("外出时间"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('flexbox', {
    attrs: {
      "gutter": 0,
      "wrap": "wrap"
    }
  }, [_c('flexbox-item', {
    attrs: {
      "span": 1 / 2
    }
  }, [_c('a', {
    staticClass: "chooseDate",
    on: {
      "click": _vm.chooseStartDate
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.startDate) + "\n                            "), _c('img', {
    staticClass: "icon right",
    attrs: {
      "src": "http://app.ecms.gczj.com.cn/wx37010/app/src/assets/icon/date-blue.png",
      "width": "18",
      "height": "18"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("~")])])]), _vm._v(" "), _c('flexbox-item', {
    attrs: {
      "span": 1 / 2
    }
  }, [_c('a', {
    staticClass: "chooseDate",
    staticStyle: {
      "padding-left": "15px"
    },
    on: {
      "click": _vm.chooseEndDate
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.endDate) + "\n                            "), _c('img', {
    staticClass: "icon right",
    staticStyle: {
      "right": "5px"
    },
    attrs: {
      "src": "http://app.ecms.gczj.com.cn/wx37010/app/src/assets/icon/date-blue.png",
      "width": "18",
      "height": "18"
    }
  })])])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("外出天数（天）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dateDiffer) + "\n            ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("本月已外出次数")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.overtimeTimes))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("项目指令号")]), _vm._v(" "), _c('td', [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.projectOrder),
      callback: function($$v) {
        _vm.projectOrder = $$v
      },
      expression: "projectOrder"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("项目名称")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.projectChoosed.projectName) + "\n            ")]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.clearProject
    }
  }, [_vm._v("清除")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("外出类型"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "select_td"
    }
  }, [_c('group', [_c('cell-box', {
    attrs: {
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectOutTimeType($event)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.outTimeTypeLabel) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("外出地点")]), _vm._v(" "), _c('td', [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.areaName),
      callback: function($$v) {
        _vm.areaName = $$v
      },
      expression: "areaName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("外出事由"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-textarea', {
    attrs: {
      "max": 200,
      "show-counter": false,
      "height": 50,
      "rows": 4,
      "cols": 30,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.outtimeReason),
      callback: function($$v) {
        _vm.outtimeReason = $$v
      },
      expression: "outtimeReason"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("外出联系方式"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-textarea', {
    attrs: {
      "max": 200,
      "show-counter": false,
      "height": 50,
      "rows": 4,
      "cols": 30,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.connectionMode),
      callback: function($$v) {
        _vm.connectionMode = $$v
      },
      expression: "connectionMode"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    staticClass: "dialog-part",
    model: {
      value: (_vm.showToast),
      callback: function($$v) {
        _vm.showToast = $$v
      },
      expression: "showToast"
    }
  }, [_c('div', {
    staticClass: "dialog-close-btn",
    on: {
      "click": function($event) {
        _vm.showToast = false
      }
    }
  }, [_c('span', [_c('img', {
    staticStyle: {
      "padding": "8px 10px 0px 0px"
    },
    attrs: {
      "slot": "label",
      "src": "http://app.ecms.gczj.com.cn/wx37010/app/src/assets/icon/close.png",
      "width": "24",
      "height": "24"
    },
    slot: "label"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-input"
  }, [_c('p', [_c('x-input', {
    attrs: {
      "id": "projectName",
      "title": "项目名称",
      "placeholder": "    请输入",
      "show-clear": true
    },
    model: {
      value: (_vm.projectName),
      callback: function($$v) {
        _vm.projectName = $$v
      },
      expression: "projectName"
    }
  }, [_c('x-button', {
    staticClass: "dialog-btn",
    attrs: {
      "slot": "right",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.searchProject($event)
      }
    },
    slot: "right"
  }, [_vm._v("搜索")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-part"
  }, [(this.projectList.length > 0) ? _c('x-table', {
    staticStyle: {
      "background-color": "#fff",
      "width": "100%"
    },
    attrs: {
      "full-bordered": ""
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "dialog-title-tr"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("项目名称")]), _vm._v(" "), _c('td', [_vm._v("项目地址")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.projectList), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticClass: "dialog-switch-td"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.projectChoosed),
        expression: "projectChoosed"
      }],
      attrs: {
        "type": "radio",
        "name": ""
      },
      domProps: {
        "value": item,
        "checked": _vm._q(_vm.projectChoosed, item)
      },
      on: {
        "change": function($event) {
          _vm.projectChoosed = item
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.projectName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.projectAddress))])])
  }))]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "dialog-bottom-bar"
  }, [(this.projectList.length > 0) ? _c('span', [_c('x-button', {
    staticClass: "dialog-btn btn-prev",
    attrs: {
      "mini": "",
      "disabled": _vm.preStatus
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getPrePage($event)
      }
    }
  }, [_vm._v("上一页")]), _vm._v("\n        " + _vm._s(_vm.pageNum) + "/" + _vm._s(_vm.projectAllNum) + "页\n        "), _c('x-button', {
    staticClass: "dialog-btn btn-next",
    attrs: {
      "mini": "",
      "disabled": _vm.nextStatus
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getNextPage($event)
      }
    }
  }, [_vm._v("下一页")])], 1) : _vm._e(), _vm._v(" "), _c('x-button', {
    staticClass: "dialog-btn btn-confirm",
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseProject($event)
      }
    }
  }, [_vm._v("确定")])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    model: {
      value: (_vm.outTimeTypeFlag),
      callback: function($$v) {
        _vm.outTimeTypeFlag = $$v
      },
      expression: "outTimeTypeFlag"
    }
  }, [_c('popup-header', {
    attrs: {
      "title": "请选择外出类型",
      "show-bottom-border": false
    }
  }), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('radio', {
    attrs: {
      "options": _vm.outTimeTypeList
    },
    on: {
      "on-change": _vm.getOutTimeType
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e94c3bf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/launch/attendance/outTime.vue
// module id = nWzI
// module chunks = 0